<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 60 60"
    role="presentation"
    :fill="iconColor"
    data-cy="svg--container-allowed">
    <defs>
      <path id="acontainer" d="m54 25.418h-1.293l-21.948-8.287a4.72 4.72 0 0 0 .987-2.893 4.755 4.755 0 0 0 -3.164-4.475v-.543a4.754 4.754 0 0 0 3.164-4.474 4.752 4.752 0 0 0 -4.746-4.746 4.752 4.752 0 0 0 -4.746 4.746 4.754 4.754 0 0 0 3.164 4.474v3.436h1.582c.872 0 1.582.71 1.582 1.582 0 .792-.585 1.448-1.346 1.563l-.236-.091-.236.09a1.583 1.583 0 0 1 -1.346-1.563h-3.164c0 1.088.369 2.091.987 2.893l-21.948 8.288h-1.293v28.582h54zm-27-22.254c.872 0 1.582.71 1.582 1.582s-.71 1.582-1.582 1.582-1.582-.71-1.582-1.582.71-1.582 1.582-1.582zm0 15.93 16.75 6.324h-33.5zm23.836 31.742h-47.672v-22.254h47.672zm-44.402-19.09v15.926h3.164v-15.926zm6.328 0v15.926h3.164v-15.926zm6.328 0v15.926h3.164v-15.926zm6.328 0v15.926h3.164v-15.926zm6.328 0v15.926h3.164v-15.926zm6.328 0v15.926h3.164v-15.926zm6.328 0v15.926h3.164v-15.926z"/>
      <mask id="bcontainer" fill="#fff">
        <use fill="none" xlink:href="#acontainer"/>
      </mask>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(3 2)">
      <use :fill="iconColor" fill-rule="nonzero" xlink:href="#acontainer"/>
      <g mask="url(#bcontainer)">
        <path d="m-3-2h60v60h-60z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32
    },
    height: {
      type: [Number, String],
      default: 32
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
